/**
 * Reorder an entry within the same array.
 * @param {array} list
 * @param {number} start
 * @param {number} end
 * @returns {array} The new positioned array
 */
export default (list, { start, end }) => {
  const listClone = [...list];
  const [removed] = listClone.splice(start, 1);

  listClone.splice(end, 0, removed);

  return listClone;
};
